import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

import { useUtils } from '@core/libs/i18n'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import filters from "@/views/modules/Utils/filters";

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const { t } = useUtils()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'name', sortable: true, label: t('Name')},
    { key: 'email', sortable: true ,label:t('email')},
    { key: 'role', sortable: true ,label:t('role')},
    { key: 'expire_at', sortable: true ,label:t('expire_at')},
    { key: 'actions',label:t('actions') },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('created_at')
  const isSortDirDesc = ref(true)


  const roleFilter = ref(null)
  const contractFilter = ref(null)
  const managerFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const requestStatus = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  const filter = ref({})

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter, managerFilter, contractFilter], () => {

    filter.value = {
      ...(managerFilter.value && {manager: managerFilter.value}),
      ...(roleFilter.value && {role: roleFilter.value}),
      ...(contractFilter.value && {contract: contractFilter.value}),
      ...((statusFilter.value in [0,1]) && {enabled: statusFilter.value}),
      ...(searchQuery.value && {q: searchQuery.value})
    }

    refetchData()
  })


  // const { managersOptions, rolesOptions, contractsOptions } = filters('user')

  const fetchUsers = (ctx, callback) => {
    requestStatus.value = true
    store
      .dispatch('appUser/fetchUsers', {
        q: searchQuery.value,
        length: perPage.value,
        page: currentPage.value,
        sortBy:isSortDirDesc.value==true? sortBy.value+',desc':sortBy.value+',asc',
        ...filter.value
      })
      .then(response => {
        requestStatus.value = false
        callback(response.data.users.data)
        totalUsers.value = response.data.users.meta.total

      })
      .catch(() => {
        requestStatus.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'admin') return 'primary'
    if (role === 'user') return 'success'
    if (role === 'manager') return 'info'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'user') return 'UserIcon'
    if (role === 'manager') return 'KeyIcon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = enabled => {
    return enabled === 0 ? 'success' : 'secondary'
  }

  return {
    fetchUsers,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    requestStatus,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,


    // managersOptions,
    // contractsOptions,
    // rolesOptions,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
